"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schedulableHasDuration = exports.isSchedulableOfType = exports.eventTypeHasDuration = exports.SHUTDOWN_SCHEDULABLE = exports.CHECK_FOR_UPDATE_SCHEDULABLE = exports.BROADCAST_MESSAGE_SCHEDULABLE = void 0;
var CHECK_FOR_UPDATE_SCHEDULABLE = exports.CHECK_FOR_UPDATE_SCHEDULABLE = {
  value: "check-updates",
  type: "SYS_OPS"
};
var BROADCAST_MESSAGE_SCHEDULABLE = exports.BROADCAST_MESSAGE_SCHEDULABLE = {
  value: "broadcast-message",
  type: "SYS_OPS"
};
var SHUTDOWN_SCHEDULABLE = exports.SHUTDOWN_SCHEDULABLE = {
  value: "shutdown",
  type: "SYS_OPS"
};
var isSchedulableOfType = exports.isSchedulableOfType = function isSchedulableOfType(item, type) {
  return item.id.value === type.value && item.id.type === type.type;
};
var eventTypeHasDuration = exports.eventTypeHasDuration = function eventTypeHasDuration(type) {
  return type === "MAPPER" || type === "ALERT";
};
var schedulableHasDuration = exports.schedulableHasDuration = function schedulableHasDuration(item) {
  return eventTypeHasDuration(item.type);
};